import axios from "axios";

export const baseURL =
  process.env.REACT_APP_BASE_URL || "http://localhost:5000";
export const apiURL = process.env.REACT_APP_API_URL || "http://localhost:5000";
const api = axios.create({
  baseURL: `${apiURL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect on 401 if it's an auth error (not login attempt)
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes("/auth/");
      if (!isLoginRequest) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Check user role to redirect appropriately
        const currentPath = window.location.pathname;
        if (currentPath.startsWith("/member")) {
          window.location.href = "/member/login";
        } else {
          window.location.href = "/admin/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
